import {LinearProgress, makeStyles, Button, useTheme} from '@material-ui/core';
import Typography from '@material-ui/core/Typography/Typography';
import useRouter from 'packages/hooks/use-router';
import {FormProvider, useForm} from 'react-hook-form';
import loginImage from 'packages/assets/images/loginImage.jpg';
import useAppAuth from 'packages/hooks/use-app-auth';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Redirect} from 'react-router-dom';
import useCommonStyles from 'packages/common-utils/common-styles';
import clsx from 'clsx';
import LoginForm from './Form';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'grid',
  },

  left: {
    position: 'relative',
    backgroundImage: `url(${loginImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    background: 'linear-gradient(26.82deg, #39C6C6 -24.85%, #2c91382b 98.25%)',
  },
  rightSide: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: theme.spacing(8, 8),
  },
  registerTitle: {
    margin: 0,
    fontSize: 31,
    fontWeight: 700,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(2),
    width: '100%',
  },
  content: {
    paddingTop: theme.spacing(2),
  },
}));

type ILoginForm = {
  emailInput: string;
  passwordInput: string;
};

const Login = () => {
  const classes = useStyles();
  const common = useCommonStyles();
  const methods = useForm<ILoginForm>();
  const {history} = useRouter();
  const theme = useTheme();
  const {authenticated, isAdmin} = useAppAuth();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  if (authenticated && isAdmin) return <Redirect to="/admin" />;
  if (authenticated && !isAdmin) return <Redirect to="/app" />;

  return (
    <>
      {false && <LinearProgress />}
      <FormProvider {...methods}>
        <div
          id="login-container"
          className={clsx([
            classes.root,
            matches ? common.fullRow : common.sideBySide,
          ])}
        >
          <div className={clsx([classes.left, matches && common.hide])}>
            <div className={classes.backdrop} />
          </div>
          <div className={classes.rightSide}>
            <div className={classes.column}>
              <h1 className={classes.registerTitle}>Iniciar sesión</h1>
              <Typography color="textSecondary" variant="h6">
                Revisa que torneos tenemos disponibles e inscribete para ganar
              </Typography>
            </div>
            <div className={classes.content}>
              <LoginForm />
            </div>
            <Button
              onClick={() => history.push('/register')}
              color="primary"
              name="register-btn"
            >
              No tengo cuenta
            </Button>
          </div>
        </div>
      </FormProvider>
    </>
  );
};

export default Login;
